<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="670px"
    :innerScroll="false"
    :loading="loading"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form ref="addForm" :model="addForm" :rules="rules" label-width="110px" size="small" class="content">
      <el-row>
        <el-col :span="12">
          <el-form-item label="商品编码:" prop="goodsCode">
            <el-input v-model.trim="addForm.goodsCode" @blur="getNameByCode" :disabled="title == '编辑'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="商品名称:">
            <el-tooltip
              class="item"
              effect="dark"
              :content="addForm.goodsName"
              placement="top-start"
              v-if="addForm.goodsName && addForm.goodsName.length >= 13"
            >
              <div class="textTips">{{ addForm.goodsName || "" }}</div>
            </el-tooltip>
            <div class="textTips" v-else>{{ addForm.goodsName || "" }}</div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="发货周期:" prop="deliveryCycle">
            <el-input v-model.trim="addForm.deliveryCycle"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="适用店铺:" prop="storeCodeList">
            <el-select v-model="addForm.storeCodeList"  multiple collapse-tags filterable placeholder="请选择" @change="storeCodeChange">
              <el-option label="全部" value="" v-show="!all"></el-option>
              <el-option v-if="all" label="取消所有" value="cancleAll"></el-option>
              <el-option v-for="item in storeListEdit" :key="item.storeCode" :label="item.storeName" :value="item.storeCode"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </q-dialog>
</template>

<script>
import moment from "moment";
import axios from "@/utils/axiosInstance";
export default {
  name: "CRUDEdit",
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    storeListEdit: {
      type: Array,
      default: [],
    },
    rowData: Object,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return this.rowData ? "编辑" : "新增";
    },
    userName() {
      return this.$store.state.user.name;
    },
  },
  data() {
    return {
      loading: false,
      all: false,
      addForm: {
        storeCodeList: []
      },
      rules: {
        goodsCode: [{ required: true, message: "不能为空", trigger: "blur" }],
        storeCodeList: [{ required: true, message: "不能为空", trigger: "change" }],
        deliveryCycle: [{ required: true, message: "不能为空", trigger: "blur" }],
      },
      imgList: "",
      textForm: {},
    };
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        let addForm = {
          ...this.addForm,
        };
        this.$q.goods
          .deliverySaveOrUpdate({ data: addForm })
          .then((res) => {
            if (res.code == 200) {
              let text = this.title + "成功";
              this.$message.success(text);
              this.isVisible = false;
              this.$emit("success");
            }
          })
          .finally((_) => {
            this.loading = false;
          });
      });
    },
    getNameByCode() {
      let str = this.addForm.goodsCode;
      if (!str) {
        return;
      }
      if (str.trim() === "") {
        return;
      }
      this.$q.goods
        .getNameByCode({ params: { goodsCode: str } })
        .then((res) => {
          this.$set(this.addForm,'goodsName',res.data)
        });
    },
    storeCodeChange(val) {
      this.all = val.length == this.storeListEdit.length
      if (val.includes("")) {
        this.addForm.storeCodeList = this.storeListEdit.map((v) => v.storeCode);
        this.all = true;
      } else if (val.includes("cancleAll")) {
        this.addForm.storeCodeList = [];
        this.all = false;
      }
    },
  },
  created() {
    if (this.rowData) {
      this.addForm = this.rowData;
      this.$set(this.addForm,'deliveryCycleOld',this.addForm.deliveryCycle)
      if (this.addForm.storeCode) {
        this.$set(this.addForm, "storeCodeList", this.rowData.storeCode.split(","));
        this.storeCodeChange(this.addForm.storeCodeList)
      }
    }
  },
};
</script>

<style lang="stylus" scoped>

>>> .el-form-item {
  margin-bottom: 18px
}

// >>> .el-dialog {
//   margin: 50px auto !important
// }

>>> .el-input--small .el-input__inner, >>> .el-input--suffix .el-input__inner, >>> .el-input--suffix {
  height: 32px;
  line-height: 32px;
  width: 200px !important;
}

>>> .el-date-editor.el-input {
  width: 200px
}

>>> .el-form-item__content .textTips {
  cursor: pointer
  overflow: hidden
  white-space: nowrap;
  text-overflow: ellipsis
}

>>> .el-select__tags-text {
display: inline-block;
max-width: 60px;
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;
}
>>> .el-tag__close.el-icon-close {
  top: 0px;
  right: -4px
}

</style>
